import { Injectable } from '@angular/core';

@Injectable()
export class LoginService {
  walkUser: any;
  response: Response;
  public static isLoggedIn: boolean = false;
  public userAdmin: boolean = false;

  constructor() {
    this.walkUser = {};
  }

  setCredentials(username, tenant, token) {
    localStorage.setItem('currentUser', JSON.stringify({ username: username, tenant: tenant, token: token }))
    LoginService.isLoggedIn = true;
  }

  clearCredentials() {
    localStorage.removeItem('currentUser')
  }

  setUserAdmin(isAdmin) {
    console.log("is admin set to : " + isAdmin)
    this.userAdmin = isAdmin;
  }

  getWalkUser() {
    return this.walkUser;
  }
  
  IsUserAdmin() {
    return this.userAdmin;
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/login.service.ts